import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { SiteFooter } from '@/components/generals/site-footer'
import { SiteHeader } from '@/components/generals/site-header'

export const Layout: FC<LayoutProps> = ({ site, children }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a
                href='#main'
                className='sr-only rounded-full bg-primary px-4 py-2 text-sm font-medium text-primary-foreground focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50'
            >
                Skip to content
            </a>

            <SiteHeader profile={site.profile} />

            <main id='main' className='flex-1'>
                {children}
            </main>

            <SiteFooter profile={site.profile} socialLinks={site.socialLinks} />
        </div>
    )
}
